export const statusMap = {
    2: 'pending',
    4: 'accepted',
    5: 'auto accepted',
    8: 'disputed'
};
